import { Box } from '@mui/material'
import React from 'react'
import { ActionObject, BlankView } from 'src/Components/blank-view'

interface Props {
  onActionClick: () => void
}

/**
 * Page informs user that app cannot be used until a newer app version is installed.
 */
const AppUpdatePage: React.FC<Props> = ({ onActionClick }) => {
  const actionObject: ActionObject = {
    text: 'mobile-app-update.update-page.action-button-text',
    onClick: onActionClick,
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        height: '100%',
        width: '100%',
        left: 0,
        top: 0,
        zIndex: 'modal',
        backgroundColor: 'common.white',
      }}
    >
      <Box sx={{ p: 2, height: '100%' }}>
        <BlankView
          imageVariant="NEUTRAL"
          title="mobile-app-update.update-page.title"
          explanation="mobile-app-update.update-page.explanation"
          action={actionObject}
        />
      </Box>
    </Box>
  )
}

export default AppUpdatePage
